import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL, IMAGE_URL } from "../../../config/axios";
import usePermission from "../../../config/permissions";
import { CustomImageModal, handleErrorToast } from "../../CustomFunctions";
import { UpdatePencil, DeleteDustbin, Office } from "../../AllSvg";
import { AddAttendanceSetupModal, DeleteAttendanceSetupModal } from "./AppraisalSetupComponents";
import { formatDateTime } from "../../Date";
import UserDefaultLogo from "../../UserDetails/UserDefaultLogo";



const AttendanceSetupTable = () => {
    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id") || "null");
    const [configData, setConfigData] = useState(null);
    const [buffer, setBuffering] = useState(false);

    const fetchConfig = async () => {
        if (!toggleCompany || toggleCompany === "null") {
            setConfigData(null);
            return;
        }
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/star-performance-attendance-rating-config-filter-by-sub-company/?sub_company=${toggleCompany}`);
            let data = res.data;
            data = Array.isArray(data) && data.length > 0 ? data : null;
            setConfigData(data);
        } catch (error) {
            handleErrorToast(error);
            setConfigData(null);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        fetchConfig();
    }, [toggleCompany]);



    return (
        <div className="table-css-white-background mt-3">
            <div className="table-heading-flex">
                <div className="repo-heading font-weight500 font-size-heading">Attendance Rating Configuration</div>
                <div className="field-cont">
                    {SUPER_ADMIN && (
                        <div className="table-searchh dropdown-container field-cont-div" style={{ width: '250px' }}>
                            <Office />
                            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading w-100">
                                <option value="null">Select Sub Company</option>
                                {SUB_COMPANIES?.map((company) => (
                                    <option key={company.id} value={company.id}>{company.title}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {(!configData || configData.length === 0) && toggleCompany !== "null" && (
                        <AddAttendanceSetupModal
                            SUPER_ADMIN={SUPER_ADMIN}
                            SUB_COMPANIES={SUB_COMPANIES}
                            subCompanyId={toggleCompany}
                            refreshData={fetchConfig}
                            existingConfig={null}
                        />
                    )}

                </div>
            </div>

            <table className="table-css">
                <thead>
                    <tr className="custom-table-head-tr">
                        <th className="align-left">Sr No.</th>
                        <th className="align-center">Total Score</th>
                        <th className="align-center">Late Coming Deduction</th>
                        <th className="align-center">Halfday Deductions</th>
                        <th className="align-center">Absent Deduction</th>
                        <th className="align-center">Star Performance</th>
                        <th className="align-center">Star Performance Total Marks</th>
                        <th className="align-center">Subcompany</th>
                        <th className="align-center">Created At</th>
                        <th className="align-center">Last Update</th>
                        <th className="align-right width-5vw">Action</th>
                    </tr>
                </thead>

                {buffer ? (
                    <tbody>
                        <tr>
                            <td colSpan="12" className="align-center">
                                <div className="spinner"></div>
                            </td>
                        </tr>
                    </tbody>
                ) : (

                    <tbody>
                        {configData?.length > 0 ? (
                            configData
                                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                .map((i, index) => (
                                    <React.Fragment key={i.id}>
                                        <tr className="tr-border-bottom">
                                            <td colSpan="12"></td>
                                        </tr>
                                        <tr className="custom-table-head-td">
                                            <td className="align-left">{index + 1}</td>

                                            <td className="align-center">{i?.total_marks}</td>
                                            <td className="align-center">{i?.late_deduction}</td>
                                            <td className="align-center">{i?.half_day_deduction}</td>
                                            <td className="align-center">{i?.absent_deduction}</td>
                                            <td className="align-center">{i?.star_performance_name}</td>
                                            <td className="align-center">{i?.star_performance_total_marks}</td>
                                            <td className="align-center">{i?.sub_company_title}</td>
                                            <td className="align-center">
                                                {formatDateTime(i?.created_at).shortfull}
                                            </td>
                                            <td className="align-center">
                                                <>
                                                    {i.created_by &&
                                                        <>
                                                            <CustomImageModal customStyle>
                                                                {i.created_by_profilepic ? (
                                                                    <img
                                                                        src={`${`${IMAGE_URL}${i.created_by_profilepic}`}`}
                                                                        alt="profile" className="profile-img"
                                                                    />
                                                                ) : (
                                                                    <UserDefaultLogo user={{ name: i.created_by_name, profilepic: i.created_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                )}
                                                            </CustomImageModal>
                                                            <p>{`${i.created_by} - `}{i.created_by_name}</p>

                                                        </>
                                                    }
                                                    <small>{i?.created_at && formatDateTime(i?.created_at).shortfull}</small>
                                                </>
                                            </td>
                                            <td className="align-center">
                                                <>
                                                    {i.updated_by &&
                                                        <>
                                                            <CustomImageModal customStyle>
                                                                {i.updated_by_profilepic ? (
                                                                    <img
                                                                        src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                                                        alt="profile" className="profile-img"
                                                                    />
                                                                ) : (
                                                                    <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                                                                )}
                                                            </CustomImageModal>
                                                            <p>{`${i.updated_by} - `}{i.updated_by_name}</p>

                                                        </>
                                                    }
                                                    <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                                                </>
                                            </td>

                                            <td className="align-center">
                                                <div className="flex-row">
                                                    {/* for editing the attendance setup, we are using the same modal component as for adding, but passing the existing config data to it. */}
                                                    <AddAttendanceSetupModal
                                                        SUPER_ADMIN={SUPER_ADMIN}
                                                        SUB_COMPANIES={SUB_COMPANIES}
                                                        subCompanyId={toggleCompany}
                                                        refreshData={fetchConfig}
                                                        existingConfig={i}
                                                    />

                                                    {/* delete modal */}
                                                    <DeleteAttendanceSetupModal
                                                        existingConfig={i}
                                                        refreshData={fetchConfig}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                        ) : (
                            <tr>
                                <td colSpan="12" className="align-center">
                                    No attendance configuration found for this company. Click "Add Setup" to create one.
                                </td>
                            </tr>
                        )}
                    </tbody>
                )}
            </table>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

        </div>
    );
};

export default AttendanceSetupTable;
